
import React, { useState } from 'react';
import MonacoEditor from '@monaco-editor/react';
import CompletionPopup from '../completion-popup';
import { serverURL } from '../../config/urls';
import { logEvent } from '@firebase/analytics';
import {analytics} from '../../config/firebase-logging';
import { useCareerContext } from '../career-context';

export function IfStatements() {
    const {
        isPopupOpen,
        setIsPopupOpen,
        startConfetti
    } = useCareerContext();
    const options = { scrollbar: { alwaysConsumeMouseWheel: false, }, scrollBeyondLastLine: false, minimap: { enabled: false, } }

    const [code, setCode] = useState(
`def login(username_exists, given_password, actual_password):
    if username_exists == :
        return "Username not found"
    elif :
        return "Incorrect password"
    else:
        return "Login successful"`
    );
    const [output, setOutput] = useState('');

    function handleEditorChange(newValue, event) {
        setCode(newValue);
    }

    async function runCode() {
        if (process.env.REACT_APP_ENVIRONMENT === "production") {
            logEvent(analytics, 'career_interaction')
        }
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code }),
        };
        const response = await fetch(serverURL + "/if_statements", requestOptions);
        const result = await response.json();
        if (result.error) {
            setOutput(result.error);
        } else if (result.verdict === "Fail") {
            setOutput(`Test login(${result.test[0]}, "${result.test[1]}", "${result.test[2]}") failed.\nExpected: "${result.expected}", got "${result.result}" instead`)
        } else {
            setOutput("");
            setIsPopupOpen(true);
            startConfetti();
        }
    }

    function hidePopup() {
        setIsPopupOpen(false);
    }


    return (
        <>
            {isPopupOpen && <CompletionPopup title="Great Job!" message="Looks like you have a great understanding of if statements!" hidePopup={hidePopup} />}

            <h2 className='blue'>Authenticating Users</h2>
            <p>
                Now you will handle the login process for users! Complete the function <code>login(username_exists, given_password, actual_password)</code> where <code>username_exists</code> is a boolean indicating if the given username exists, <code>given_password</code> is the password the user entered, and <code>actual_password</code> is the correct password for the account. If the username doesn't exist in our database, return <code><span className='string'>"Username not found"</span></code>. otherwise, if the given password doesn't match the actual password, return <code><span className='string'>"Incorrect password"</span></code>. Otherwise, return <code><span className='string'>"Login successful"</span></code>. Much of code is already written for you, you just need to fill in the blanks!
            </p>
            <p>Examples</p>
            <ul>
                <li><code>login(False, None, None)</code> returns <code><span className='string'>"Username not found"</span></code></li>
                <li><code>login(True, <span className='string'>"091823"</span>, <span className='string'>"asjd299"</span>)</code> returns <code><span className='string'>"Incorrect password"</span></code></li>
                <li><code>login(True, <span className='string'>"password"</span>, <span className='string'>"password"</span>)</code> returns <code><span className='string'>"Login successful"</span></code></li>
            </ul>

            <div className='row' style={{ alignItems: "flex-start" }}>
                <div style={{ width: (output) ? "50%" : "100%" }}>
                    <div className='editor-padding'></div>
                    <MonacoEditor theme='vs-dark' language='python' height="175px" value={code} onChange={handleEditorChange} options={options} />
                    <button className='primary-btn blue-bg' style={{ marginTop: "5px" }} onClick={runCode}>Submit</button>
                </div>
                
                {output && <pre className='output' style={{ height: "175px" }}>{output}</pre>}

            </div>
        </>
    );
}

